import axios from 'axios';

const PortalSchoolSubject = {
    namespaced: true,
    actions: {       
        PortalGetSchoolSubjects({ rootState }, OptionId) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSubject/PortalGetSchoolSubjects?OptionId=${OptionId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetSchoolTeacherSubjects({ rootState }, OptionId) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalSchoolSubject/GetSchoolTeacherSubjects?OptionId=${OptionId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
       
    }
}

export default PortalSchoolSubject